import { Box, Typography } from "@mui/material";

const InfoTile = ({ title, value }) => {
  return (
    <Box>
      <Typography>{title}</Typography>
      <Typography fontWeight={600} variant="h6">
        {value}
      </Typography>
    </Box>
  );
};

export default InfoTile;
